<template>
  <NavButton v-b-tooltip.bottom.hover="tooltipTitle" :btn-key="btnKey" @click="click" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'
import { NavButtonKeys } from '@/types'

const components = {
  NavButton,
}

@Component({ components })
export default class NavBtnFilterByCategory extends Vue {
  get btnKey() {
    return NavButtonKeys.FILTER
  }

  get visualisationStore() {
    return this.$typedStore.activeVisualisation.visualisationStore
  }

  get enableSearchByLocation() {
    return this.visualisationStore.app.config.searchSettings.enableSearchByLocation
  }

  get filterByLocationActive() {
    const { currentLocation, filterRecords } = this.$typedStore.public.search
    return (
      this.enableSearchByLocation &&
      filterRecords &&
      !this.visualisationStore.app.isEmpty(currentLocation)
    )
  }

  get tooltipTitle() {
    return this.filterByLocationActive
      ? 'Cannot filter by category when search by location is active'
      : ''
  }

  click() {
    this.$bvModal.show('filter-by-category-modal')
  }
}
</script>
